const ResumeIcon = () => {
    return (
        <svg width="39px" height="21px" viewBox="0 0 39 21" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="PathPilotApp" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <g id="PPMobileChatThreadJobBoardCopy9" transform="translate(-54, -274)" stroke="#FFFFFF" strokeWidth="2">
                    <g id="Group9" transform="translate(55, 275)">
                        <path d="M13.4319,4.711 C13.4319,7.313 11.3219,9.423 8.7199,9.423 C6.1169,9.423 4.0079,7.313 4.0079,4.711 C4.0079,2.109 6.1169,0 8.7199,0 C11.3219,0 13.4319,2.109 13.4319,4.711 Z" id="Stroke1"></path>
                        <path d="M8.72,9.4229 C1.988,9.4229 0,14.1039 0,18.1429 L17.44,18.1429 C17.44,14.1039 15.451,9.4229 8.72,9.4229 Z" id="Stroke3"></path>
                        <line x1="25.4890397" y1="15.6511" x2="36.3927" y2="15.6511" id="Stroke5"></line>
                        <line x1="25.3927" y1="8.5618" x2="36.3925219" y2="8.5618" id="Stroke7"></line>
                        <line x1="25.5009" y1="1.4726" x2="32.8669" y2="1.4726" id="Stroke9"></line>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export default ResumeIcon;
